import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Head } from '@platform/rcl';

export function PublicLayout (props) {
  const {
    children,
  } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="public-layout">
      <Head>
        <title>BookingLive</title>
        <meta name="description" content="No.1 FREE Online Booking & Reservation System - Claim your FREE account TODAY FAST - EASY - FREE: Setup your free system in minutes and start selling online immediately. Save time, increase sales, improve customer experiences and grow your business today." />
      </Head>
      {children}
    </div>
  );
}

PublicLayout.propTypes = {
  /**
   * This component can have children
   */
  children: PropTypes.node,
};

PublicLayout.defaultProps = {
  children: null,
};

export default PublicLayout;
